import styled from "styled-components";

export const Wrapper = styled("div")(({ theme, $isLoading }) => ({
  display: $isLoading ? "block" : "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: 10,
  width: "100%",

  [theme.down("md")]: {
    gridTemplateColumns: "1fr",
  },

  [theme.down("sm")]: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
}));

export const LoadingBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: "100%",
  minHeight: 50,
}));

export const TariffItem = styled("div")(({ theme }) => ({
  ...theme.paddings(10, 5),
  ...theme.mixins.flexColumn,
  alignItems: "center",
  justifyContent: "center",
  gap: 5,
  border: `1px solid ${theme.palette.fly.hairlineLight}`,
  borderRadius: 8,
  cursor: "pointer",
  width: "100%",
  transition: "border-color .2s ease",

  "&.active": {
    border: `2px solid ${theme.palette.primary.main}`,
  },
}));

export const TariffItemPrice = styled("div")(({ theme }) => ({
  textAlign: "center",
  fontSize: 18,
  color: theme.palette.text.secondary,
  fontWeight: 700,
  textTransform: "uppercase",
  paddingBottom: 5,
}));

export const TariffItemIcons = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  gap: 3,
  fontSize: 26,
  lineHeight: 1,
  color: theme.palette.primary.dark,

  /* нет багажа / невозвратный / необмениваемый — красным, серый плохо читается */
  "& .restricted": {
    color: theme.palette.error.main,
  },

  "& > div": {
    display: "flex",
    position: "relative",
  },

  "& .hand-luggage-weight": {
    position: "absolute",
    top: 9,
    fontSize: 12,
    width: "100%",
    textAlign: "center",
    fontWeight: "bold",
    lineHeight: 1,
  },

  "& .baggage-weight": {
    position: "absolute",
    top: 8,
    left: 7,
    width: 12,
    height: 12,
    textAlign: "center",
    backgroundColor: theme.palette.white,
    fontSize: 10,
    fontWeight: "bold",
    lineHeight: 1,
  },
}));

/* только в блоке тарифов: базовые иконки и доп. услуги разными рядами */
export const TariffItemIconsRows = styled("div")(({ theme }) => ({
  ...theme.mixins.flexColumn,
  alignItems: "center",
  gap: 4,
}));

export const TariffItemIconsRow = styled(TariffItemIcons)(() => ({
  flexWrap: "wrap",

  "&:empty": {
    display: "none",
  },
}));

export const TariffItemDetails = styled("div")(({ theme, $isLoading }) => ({
  fontSize: 10,
  color: theme.palette.text.secondary,
  borderBottom: $isLoading ? "none" : `1px solid ${theme.palette.text.primary}`,
  cursor: "pointer",
}));

export const TariffItemTitle = styled(TariffItemPrice)(({ theme }) => ({
  paddingBottom: 0,
  maxWidth: "100%",
  /* длинные названия брендов без пробелов не должны вылезать за плитку */
  overflowWrap: "anywhere",
}));

export const TariffItemClass = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  lineHeight: 1,
  textTransform: "capitalize",
}));

export const TariffItemButton = styled("button")(({ theme }) => ({
  padding: "6px 16px",
  border: "none",
  backgroundColor: theme.palette.button.primary,
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.white,
  borderRadius: 8,
  transition: "background-color .2s ease",

  "&:hover": {
    backgroundColor: theme.palette.button.primaryHover,
  },
}));
